import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'lib-global-styling',
  templateUrl: './global-styling.component.html',
  styleUrls: ['./global-styling.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GlobalStylingComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
